var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8998,
    cy: 20.9974,
    r: 19.5544,
    stroke: "#4E3BE4",
    strokeWidth: 1.44848
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4263 15.9278C24.5012 15.9246 23.5845 16.1039 22.7287 16.4554C21.8729 16.8069 21.0948 17.3236 20.439 17.9761C19.7831 18.6286 19.2623 19.4041 18.9064 20.258C18.5506 21.112 18.3666 22.0278 18.365 22.9529V30.0505C18.365 30.3386 18.4795 30.6149 18.6832 30.8186C18.8869 31.0224 19.1632 31.1368 19.4514 31.1368H21.9862C22.2743 31.1368 22.5506 31.0224 22.7544 30.8186C22.9581 30.6149 23.0726 30.3386 23.0726 30.0505V22.9529C23.0723 22.6239 23.1414 22.2985 23.2754 21.9979C23.4093 21.6974 23.6051 21.4285 23.85 21.2086C24.0948 20.9888 24.3833 20.8231 24.6965 20.7223C25.0097 20.6214 25.3406 20.5877 25.6678 20.6233C26.2544 20.6972 26.7935 20.9838 27.1829 21.4288C27.5722 21.8738 27.7847 22.4462 27.7801 23.0374V30.0505C27.7801 30.3386 27.8946 30.6149 28.0983 30.8186C28.302 31.0224 28.5784 31.1368 28.8665 31.1368H31.4013C31.6894 31.1368 31.9657 31.0224 32.1695 30.8186C32.3732 30.6149 32.4877 30.3386 32.4877 30.0505V22.9529C32.4861 22.0278 32.3021 21.112 31.9462 20.258C31.5904 19.4041 31.0696 18.6286 30.4137 17.9761C29.7579 17.3236 28.9798 16.8069 28.124 16.4554C27.2682 16.1039 26.3515 15.9246 25.4263 15.9278Z",
    fill: "url(#paint0_linear_43_4130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1059 17.0141H11.8469C11.2469 17.0141 10.7605 17.5005 10.7605 18.1005V30.0504C10.7605 30.6504 11.2469 31.1368 11.8469 31.1368H15.1059C15.7059 31.1368 16.1923 30.6504 16.1923 30.0504V18.1005C16.1923 17.5005 15.7059 17.0141 15.1059 17.0141Z",
    fill: "url(#paint1_linear_43_4130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4764 14.841C14.9763 14.841 16.1923 13.625 16.1923 12.1251C16.1923 10.6251 14.9763 9.40918 13.4764 9.40918C11.9764 9.40918 10.7605 10.6251 10.7605 12.1251C10.7605 13.625 11.9764 14.841 13.4764 14.841Z",
    fill: "url(#paint2_linear_43_4130)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_4130",
    x1: 7.69995,
    y1: 9,
    x2: 26.2,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0209869,
    stopColor: "#4D3BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7337EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_4130",
    x1: 7.69995,
    y1: 9,
    x2: 26.2,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0209869,
    stopColor: "#4D3BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7337EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43_4130",
    x1: 7.69995,
    y1: 9,
    x2: 26.2,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0209869,
    stopColor: "#4D3BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7337EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4b24cc6ecc6f601482977a431007e87a.svg";
export { ForwardRef as ReactComponent };